import React from 'react';
import { Outlet } from 'react-router-dom';

interface EnterpriseRootPageInterface {}

const EnterpriseRootPage: React.FC<EnterpriseRootPageInterface> = () => <Outlet />;

export default EnterpriseRootPage;
